import injector from 'vue-inject'

class ImageUrlBuilder {
  url64 = (imgPath, storeId) => `${process.env.VUE_APP_URLS_IMAGE}/${imgPath}_64.jpg`
  url128 = (imgPath, storeId) => `${process.env.VUE_APP_URLS_IMAGE}/${imgPath}_128.jpg`
  url192 = (imgPath, storeId) => `${process.env.VUE_APP_URLS_IMAGE}/${imgPath}_192.jpg`
  url512 = (imgPath, storeId) => `${process.env.VUE_APP_URLS_IMAGE}/${imgPath}_512.jpg`
  url1024 = (imgPath, storeId) => `${process.env.VUE_APP_URLS_IMAGE}/${imgPath}_1024.jpg`
}

injector.service('ImageUrlBuilder', [], ImageUrlBuilder)
